import { HttpInterceptorFn } from '@angular/common/http';

const IMPERSONATION_TOKEN_KEY = 'impersonation_token';

/**
 * HTTP interceptor that adds the impersonation token header to all requests.
 *
 * IMPORTANT: This reads directly from localStorage instead of using ImpersonationService
 * to ensure the token is included in the very first API calls on page refresh,
 * before the service has finished initializing.
 */
export const impersonationInterceptor: HttpInterceptorFn = (req, next) => {
  // Read token directly from localStorage for immediate availability on page refresh
  const token = localStorage.getItem(IMPERSONATION_TOKEN_KEY);

  if (token) {
    req = req.clone({
      setHeaders: {
        'X-Impersonation-Token': token,
      },
    });
  }

  return next(req);
};
